export default __webpack_public_path__ + "static/media/cover_color_3.213634f2.png";